export default __webpack_public_path__ + "static/media/Perpetuals_icon.a5a4e053.png";